import { Button } from "@/app/global-components/button";
import { ExpiredToken } from "@/assets";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

function ResendCode({ onClick }: { onClick: () => void }) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div className="flex flex-col gap-4">
      <div className="text-4xl font-bold">{t("comfirm.title")}!</div>
      <div className="text-gray-700">{t("comfirm.sendCode")}</div>
      <img
        width={200}
        className="text-center my-6 mx-auto"
        src={ExpiredToken}
        alt="expired token"
      />
      <div className="flex justify-end">
        <Button
          type="submit"
          className="flex flex-col justify-end items-center bg-black shadow text-white w-fit py-2 px-4 text-sm"
          onClick={onClick}
        >
          {t("comfirm.resendCode")}
        </Button>
      </div>
    </div>
  );
}

export default ResendCode;
